import { typeAlert } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { CONTROL_CENTER_ROUTE, LEGACY_CONVERSION_RESULT_PRODUCT_ID_FIELD, LEGACY_CONVERSION_RESULT_QUOTE_ID_FIELD, LEGACY_CONVERSION_RUN_TEXT, POLICY_ROUTE_BASE, } from "./constants/legacyConversion.constants";
var STATUS_ALREADY_CONVERTED = 409;
var STATUS_UNPROCESSABLE = 422;
export var shortTaskIdOf = function (taskId) {
    return taskId.replace(/-/g, "").slice(0, 6);
};
export var controlCenterTaskRoute = function (taskId) {
    return "".concat(CONTROL_CENTER_ROUTE, "?taskId=").concat(encodeURIComponent(taskId));
};
export var policyRouteOf = function (policyId, productId) {
    if (productId === void 0) { productId = ""; }
    return productId
        ? "".concat(POLICY_ROUTE_BASE, "/").concat(policyId, "/false/false/").concat(productId)
        : "".concat(POLICY_ROUTE_BASE, "/").concat(policyId, "/false");
};
export var acceptedTaskIdOf = function (data) {
    return data && typeof data === "object" && "taskId" in data
        ? String(data.taskId)
        : "";
};
export var toLegacyConversionOutcome = function (data, error, mode) {
    var _a;
    var taskId = acceptedTaskIdOf(data);
    if (taskId)
        return { kind: "queued", taskId: taskId, mode: mode };
    if (!error)
        return null;
    var failure = error;
    var code = failure.code, body = failure.body;
    if (code === STATUS_ALREADY_CONVERTED && (body === null || body === void 0 ? void 0 : body.policyId)) {
        return { kind: "alreadyConverted", policyId: body.policyId };
    }
    if (code === STATUS_UNPROCESSABLE) {
        return mode === "batch"
            ? { kind: "tooManyCodes" }
            : { kind: "inBatch", parentTaskId: (_a = body === null || body === void 0 ? void 0 : body.parentTaskId) !== null && _a !== void 0 ? _a : null };
    }
    return { kind: "failed", error: failure };
};
var resultFieldOf = function (result, field) {
    var value = result === null || result === void 0 ? void 0 : result[field];
    return typeof value === "string" || typeof value === "number"
        ? String(value)
        : "";
};
export var convertedQuoteRouteOf = function (result) {
    var quoteId = resultFieldOf(result, LEGACY_CONVERSION_RESULT_QUOTE_ID_FIELD);
    if (!quoteId)
        return null;
    return policyRouteOf(quoteId, resultFieldOf(result, LEGACY_CONVERSION_RESULT_PRODUCT_ID_FIELD));
};
export var runOutcomeOf = function (outcome) {
    if (outcome.kind === "queued" || outcome.kind === "tooManyCodes")
        return null;
    return outcome;
};
export var runToastOf = function (outcome) {
    if (outcome.kind === "alreadyConverted") {
        return {
            type: typeAlert.info,
            message: LEGACY_CONVERSION_RUN_TEXT.alreadyConverted,
        };
    }
    if (outcome.kind === "inBatch") {
        return {
            type: typeAlert.warning,
            message: LEGACY_CONVERSION_RUN_TEXT.inBatch,
        };
    }
    if (outcome.kind === "taskFailed") {
        return {
            type: typeAlert.error,
            message: outcome.message || LEGACY_CONVERSION_RUN_TEXT.taskFailed,
        };
    }
    if (outcome.kind === "completed" && !outcome.route) {
        return {
            type: typeAlert.error,
            message: LEGACY_CONVERSION_RUN_TEXT.missingResult,
        };
    }
    return null;
};
